module.exports = __webpack_public_path__ + "static/media/freshgrocer-touch-phone.15e44f4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshgrocer-touch-phone.png
// module id = 370
// module chunks = 0